import React from "react"
import styled from "styled-components"
import { devices } from "Utils/devices"

const IconContainer = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  height: 75px;
`

const SVG = styled.svg`
  ${({ isFromWidgetChoice }) =>
    isFromWidgetChoice &&
    `
    @media ${devices.tablet} {
      width: 60px; 
      height: 45px;
    }`}
`

const GanttChart = ({ isFromWidgetChoice }) => (
  <IconContainer>
    <SVG
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      isFromWidgetChoice={isFromWidgetChoice}
      x="0px"
      y="0px"
      viewBox="0 0 15 15"
      fill="none"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          className="strokeHoverSVG"
          d="M0.5 0V14.5H15M5 2.5H2M8 5.5H3M8 8.5H5M15 11.5H8"
          stroke="#787878"
        ></path>
      </g>
    </SVG>
  </IconContainer>
)

export default GanttChart
